<template>
  <div>
    <div v-if="signedIn === true" class="author-page author vcard inline-items more">
      <div class="author-thumb">
        <img alt="author" :src="getAvatarLocal()" style="width:40px;height:40px" class="avatar" />
        <span class="icon-status online"></span>
        <div class="more-dropdown more-with-triangle">
          <div class="mCustomScrollbar" data-mcs-theme="dark">
            <div class="ui-block-title ui-block-title-small">
              <h6 class="title">Your Account</h6>
            </div>

            <ul class="account-settings">
              <li @click="setProfileRoute()">
                <router-link :to="{ name: 'Profile', params: { username: getUsername } }">
                  <svg class="olymp-menu-icon">
                    <use xlink:href="/svg-icons/sprites/icons.svg#olymp-menu-icon" />
                  </svg>

                  <span>Profile</span>
                </router-link>
              </li>
              <!-- <li>
                                            <router-link to="#">
                                                <svg class="olymp-star-icon left-menu-icon"  data-toggle="tooltip" data-placement="right"   data-original-title="FAV PAGE"><use xlink:href="/svg-icons/sprites/icons.svg#olymp-star-icon"></use></svg>

                                                <span>Bookings</span>
                                            </router-link>
              </li>-->
              <li>
                <router-link :to="{name: 'AccountInfo'}">
                  <svg
                    class="olymp-star-icon left-menu-icon"
                    data-toggle="tooltip"
                    data-placement="right"
                    data-original-title="Acc Info"
                  >
                    <use xlink:href="/svg-icons/sprites/icons.svg#olymp-happy-face-icon" />
                  </svg>

                  <span>Account Info</span>
                </router-link>
              </li>
              <li>
                <router-link to>
                  <svg class="olymp-logout-icon">
                    <use xlink:href="/svg-icons/sprites/icons.svg#olymp-logout-icon" />
                  </svg>

                  <span @click="setLogout(true)">Log Out</span>
                </router-link>
              </li>
            </ul>

            <!-- <div class="ui-block-title ui-block-title-small">
              <h6 class="title">About {{projectName}}</h6>
            </div> -->
<!--
            <ul>
              <li>
                <a href="#">
                  <span>Terms and Conditions</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>FAQs</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Careers</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span>Contact</span>
                </a>
              </li>
            </ul> -->


          </div>
        </div>
      </div>
      <a href="#" class="author-name fn">
        <div class="author-title">
          {{  userName() }}
          <svg class="olymp-dropdown-arrow-icon">
            <use xlink:href="/svg-icons/sprites/icons.svg#olymp-dropdown-arrow-icon" />
          </svg>
        </div>
        <span v-if="$store.state.user.user_type === '1' ">
          <span class="author-subtitle" v-if="$store.state.user.club === null ">No Club</span>
          <span class="author-subtitle" v-else>{{$store.state.user.club}}</span>
        </span>
        <span v-else>
          <span class="author-title" style="color: #0b0b0b">@{{$store.state.user.username}}</span>
        </span>
      </a>
    </div>
    <div v-else>
      <a
        href="#"
        class="btn btn-smoke-white grn"
        id="loginBtn"
        data-toggle="modal"
        data-target="#registration-login-form-popup"
      >JOIN</a>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import avta from "@/functions/getAvatar";
import ls from "../localstorage";

let loader;
export default {
  data() {
    return {
      signedIn: false,
      user_type: "",
      id: null,
      avatar: "",
    };
  },
  computed: mapState({
    getAvatar: state => state.user.avatar,
    getUsername: state=> state.user.username,
  }),
  methods: {
    userName() {

      if (ls.checkStorage("fansData")) {
        var userData = ls.getStorage("fansData");
        if (userData[0].user_type === '1') {
          return userData[0].username;
        }else {
          return userData[0].business_name;
        }
      }else {
        if (this.$store.state.user.user_type === '1') {
          return this.$store.state.user.username;
        }else {
          return this.$store.state.fansData[0].business_name
        }
      }
    },
    getAvatarLocal() {
      var userData = localStorage.fansData;
      return avta({state:{ av: this.getAvatar, us: this.getUsername }});
    },
    setProfileRoute() {
      // return this.$router.push('profile/' + this.$store.state.user.username);
    },
    checkUserData(userData) {
      if (userData !== "" || userData !== "undefined") {
        this.userData = JSON.parse(userData);
        this.signedIn = true;
      }
    },
    showLoading() {
			let loader = this.$loader(this, this.$refs.wholeBody, {loaderType: "spinner"});
			return loader;
		},
    setLogout(val) {
      if (val === true) {
        loader = this.showLoading();
        this.axios
          .post("user/logout")
          .then(response => {
            // console.log(response.data);
            window.eventBus.$emit("logout", val);
            return response;
          })
          .catch(error => {
            return error;
            // console.log(error.response);
          });
      }
    }
  },
  mounted() {
    var userData = localStorage.fansData;
    this.user_type = this.$store.state.user.user_type;

    if (userData) {
      this.checkUserData(userData);
    }
  }
};
</script>

<style>
</style>
